import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Invoices from "./invoices";
import Complaints from "./complaints";

const PARENT_URL = "/cms/finance";

const Finance = () => {
  return (
    <Routes>
      <Route path="/invoices/*" element={<Invoices />} />
      <Route path="/complaints/*" element={<Complaints />} />
      <Route path="" element={<Navigate to={`${PARENT_URL}/invoices/chefs-farm`} replace />} />
    </Routes>
  );
};

export default Finance;
